// src/config.js

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://project-download-upload.wn.r.appspot.com/api';

export default API_BASE_URL;
